/**
 * @file
 */

import { autoHeightAnimate } from './heightAnimation.js'

export default (Drupal, once) => {

  Drupal.behaviors.dcnAccordion = {
    attach (context) {
      function closeAccordionContent(element, time) {
        const curHeight = element.offsetHeight
        element.style.height = `${curHeight}px`
        element.style.transition = ''

        requestAnimationFrame(function () {
          element.style.transition = `height ${time}ms`
          element.style.height = '0px'
        })

        element.addEventListener('transitionend', function handler() {
          element.style.transition = ''
          element.removeEventListener('transitionend', handler)
        })
      }

      once('dcn-components-accordion', '.has-paragraph-type--accordion_item .field--name-field-content-components', context).forEach(function (accordionRoot) {

        const accordionContainer = '.paragraph--type--accordion-item'
        const accordionHeader = '.field--name-field-accordion-header'
        const accordionContent = '.field--name-field-accordion-group'
        const animateTime = 200

        // add parent class for items that are videos
        accordionRoot.querySelectorAll(`${accordionContent} .paragraph--type--video`).forEach(function (videoType) {
          const videoParent = videoType.closest('.field__item')

          if (videoParent) {
            videoParent.classList.add('has-video')
          }
        })

        // toggle
        accordionRoot.querySelectorAll(accordionHeader).forEach(function (header) {
          header.addEventListener('click', function () {
            const accordionItem = header.closest(accordionContainer)

            if (!accordionItem) {
              return
            }

            const accordionGroup = accordionItem.querySelector(accordionContent)

            if (accordionItem.classList.contains('accordion-open')) {
              accordionItem.classList.add('fade-out')
              accordionItem.setAttribute('aria-expanded', 'false')

              if (accordionGroup) {
                closeAccordionContent(accordionGroup, animateTime)
              }

              setTimeout(function () {
                accordionItem.classList.remove('accordion-open')
              }, 200)
            } else {
              accordionItem.classList.add('accordion-open', 'fade-in')
              accordionItem.setAttribute('aria-expanded', 'true')

              if (accordionGroup) {
                autoHeightAnimate(accordionGroup, animateTime)
              }

              setTimeout(function () {
                accordionItem.classList.remove('fade-in')
              }, 100)
            }
          })
        })
      })
    }
  }
}
